import { useMutation } from "@tanstack/react-query"
import { updateProgramDisplayIdxByUpdateProgramAdminRequest } from "../../../../../../service/program"

const useUpdateProgramDisplayIdxByUpdateProgramAdminRequest = () => {
    const mutation = useMutation({
        mutationFn: updateProgramDisplayIdxByUpdateProgramAdminRequest,
    })

    return mutation;
}

export { useUpdateProgramDisplayIdxByUpdateProgramAdminRequest }